import { DefaultSettingsModel } from '../../valutrust-mapper-types/model/valuetrust.model';
import { DefaultSettingsModel as FNCDefaultSettingsModel } from '../../fnc-mapper-types/fnc-default-setting/model/fnc-default-setting.model';

export class GlobalConfigurationStateModel {
	acuity: {
		products?: Array<ProductsList>;
		lenderBranches?: Array<ProductsList>;
		documentTypes?: Array<IdNameObjectType>;
		loanTypes?: Array<IdNameObjectType>;
		loanReasons?: Array<IdNameObjectType>;
		propertyTypes?: Array<IdNameObjectType>;
		occupancyTypes?: Array<IdNameObjectType>;
		insideMapsProducts?: Array<ProductsList>;
		milestones?: Array<ProductsList>;
	};
	appScope: {
		products?: Array<ProductsList>;
		documentTypes?: Array<IdNameObjectType>;
		loanTypes?: Array<IdNameObjectType>;
		loanReasons?: Array<IdNameObjectType>;
		propertyTypes?: Array<IdNameObjectType>;
		occupancyTypes?: Array<IdNameObjectType>;
		lenders?: Array<ProductsList>;
	};
	cmpAcuity: {
		products?: Array<ProductsList>;
		documentTypes?: Array<IdNameObjectType>;
		loanTypes?: Array<IdNameObjectType>;
		loanReasons?: Array<IdNameObjectType>;
		propertyTypes?: Array<IdNameObjectType>;
		occupancyTypes?: Array<IdNameObjectType>;
		lenders?: Array<ProductsList>;
		milestones?: Array<ProductsList>;
	};
	classValuation: {
		documentTypes?: Array<IdNameObjectType>;
		docTypes?: Array<IdNameObjectType>;
	}
	classIntelligence: {
		formTypes ?: Array<any>;
		origins ?: Array<any>;
	};
	nexsys: {
		products?: Array<ProductsList>;
		attributesList?: Array<ProductsList>;
		statusMessageAppScope ?: Array<any>;
		statusMessageAcuity ?: Array<any>;
		statusMessageCmpAcuity ?: Array<any>;
	};
	valuTrust: {
		products?: Array<ProductsList>;
		statusMessageAppScope ?: Array<any>;
		statusMessageAcuity ?: Array<any>;
		statusMessageCmpAcuity ?: Array<any>;
	};
	xpanse: {
		products?: Array<ProductsList>;
		defaultSettings? :DefaultSettingsModel
	};
	fnc: {
		products?: Array<ProductsList>;
		defaultSettings? :FNCDefaultSettingsModel
	};
	genericIntegrations: {
		integrations?: Array<GenericIntegration>;
	}
	deliveryAssets: {
		appScope?: {
			documentTypes?: Array<IdNameObjectType>;
		},
		acuity?: {
			documentTypes?: Array<IdNameObjectType>;
		},
		classValuation?: {
			documentTypes?: Array<IdNameObjectType>;
		},
		cmpAcuity?: {
			documentTypes?: Array<IdNameObjectType>;
		}
	}
	trackingSystems: Array<IdNameObjectType>;
	handleMode: Array<string>;
	enums?: {
		actions?: Array<IdNameObjectType>;
		cmpOnHoldReasons?: Array<IdNameObjectType>;
		receiveFromClient?: Array<IdNameObjectType>;
	}
}
export interface GenericIntegration {
	integrationId: string;
	integrationName: string;
	updatedBy?: string;
	created?: string;
	updated?: string;
}
export interface ProductsList {
	id: string;
	title: string;
}

export interface IdNameObjectType {
	id: string;
	name: string;
}
